import {
  GET_MASTER_BOARDING_DATA,
  GET_DEFAULT_MASTER_DATA
} from './../constants/actionTypes'
import get from 'lodash/get'

const masterBoardingSlots = (store = [], action = []) => {
  switch (action.type) {
    case GET_MASTER_BOARDING_DATA:
      return get(action, 'data', [])
    default:
      return store
  }
}
const defaultMasterDataList = (store = [], action = []) => {
  switch (action.type) {
    case GET_DEFAULT_MASTER_DATA:
      return get(action, 'data', [])
    default:
      return store
  }
}

export { masterBoardingSlots, defaultMasterDataList }
